<mat-radio-button [value]="value" class="wrap" color="primary" labelPosition="before" [disabled]="isDisabled">
    <!-- top -->
    <div class="label">{{label | translate}}</div>
    
    @if (hasContent) {
    <div class="content">
        <ng-content select="[content]"></ng-content>
    </div>
    }
    
    @if (hasBottom) {
    <div class="bottom">
        <ng-content select="[bottom]"></ng-content>
    </div>
    }
</mat-radio-button>
